// Copyright (C) 2024 Charles Thompson. SPDX-License-Identifier: MIT
export const DEFAULT_NOTE_HUES = Object.freeze([
    0, 25, 45, 75, 110, 166, 190, 210, 240, 270, 300, 330,
]);
export function resolveOptions({ analyser = null, minSemitone = 12, maxSemitone = 108, brightnessPower = 1, lengthPower = 1, noteHues = DEFAULT_NOTE_HUES, showNoteLabels = false, showFrequencyLabels = false, showScroll = false, paused = false, maxWidth = null, maxHeight = null, ariaLabel = 'Audio frequency spectrum', }) {
    if (!Number.isFinite(minSemitone) || !Number.isFinite(maxSemitone) || minSemitone >= maxSemitone) {
        throw new RangeError('minSemitone must be less than maxSemitone, and both must be finite.');
    }
    if (![brightnessPower, lengthPower].every((value) => Number.isFinite(value) && value > 0)) {
        throw new RangeError('brightnessPower and lengthPower must be positive finite numbers.');
    }
    if (!Array.isArray(noteHues) || noteHues.length !== 12 || !noteHues.every(Number.isFinite)) {
        throw new RangeError('noteHues must contain twelve finite hue values, ordered C through B.');
    }
    for (const size of [maxWidth, maxHeight]) {
        if (size !== null &&
            typeof size !== 'string' &&
            !(typeof size === 'number' && Number.isFinite(size) && size >= 0)) {
            throw new RangeError('Maximum dimensions must be CSS strings, non-negative finite numbers, or null.');
        }
    }
    return {
        analyser,
        minSemitone,
        maxSemitone,
        brightnessPower,
        lengthPower,
        noteHues: [...noteHues],
        showNoteLabels,
        showFrequencyLabels,
        showScroll,
        paused,
        maxWidth,
        maxHeight,
        ariaLabel,
    };
}
export const FILL_CONTAINER_STYLE = {
    position: 'relative',
    width: '100%',
    height: '100%',
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
};
export function cssSize(size) {
    return typeof size === 'number' ? `${size}px` : (size ?? '');
}
